<template>
  <quill-editor
    class="qs_editor mb-1"
    :class="['is-' + state]"
    v-model="text"
    :ref="reference"
    :options="editorOption"
    >
  </quill-editor>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';

export default {
  name: 'editor',
  components: {
    quillEditor,
  },
  props: {
    model: {
      type: String,
      default() {
        return '';
      },
    },
    reference: {
      type: String,
      default: 'editor',
    },
    placeholder: {
      type: String,
      default: 'Text formatado',
    },
    state: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      quill: null,
      editorOption: {
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, 5, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
          ],
        },
      },
    };
  },
  methods: {
    // onEditorBlur(quill) {
    //   // console.log('editor blur!', quill);
    // },
    // onEditorFocus(quill) {
    //   // console.log('editor focus!', quill);
    // },
    // onEditorReady(quill) {
    //   // console.log('editor ready!', quill);
    // },
    // onEditorChange({ quill, html, text }) {
    //   // console.log('editor change!', quill, html, text);
    //   this.content = html;
    // },
  },
  computed: {
    text: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit('update:model', value);
      },
    },
    editor() {
      return this.$refs[this.reference].quill;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.is-invalid /deep/ .ql-container.ql-snow {
  border: 1px solid $red;
}
</style>
